// extracted by mini-css-extract-plugin
module.exports = {"panel":"PrivacyRequestButton_panel__ejRMD","description":"PrivacyRequestButton_description__Aew1X","trigger":"PrivacyRequestButton_trigger__H2Uj8"};